import * as stylex from "@stylexjs/stylex";
export function NoteDetails({
  text
}: {
  text: string;
}) {
  return <div className="x7wgvq7 x1auvmeq xo1l8bm xrg9stw x132q4wb x1fj9vlw x1fzhlzt xj0a0fe">{text}</div>;
}